export default "__VITE_ASSET__CAqQhuuZ__"